export default {"src":"/_next/static/media/icon_play_headtohead_v2.598b8178.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};